export default customElements.define('w-gauge-bar', class GaugeBar extends wealthify.CustomElementBaseClass {

    constructor() {
        const config = {
            styleSelector: 'c-gauge-bar',
            templateHTML: `
            <div data-root>
                <label data-title class='c-gauge-bar__title'></label>
                <label data-threshold-label class='u-display__hidden'></label>
                <div id='' data-meter role='meter' aria-valuemin='0' class='c-gauge-bar__bar-container' data-barcontainer>
                    <div class='c-gauge-bar__bar-inner-container'>
                        <div data-bar class='c-gauge-bar__bar'></div>
                    </div>
                    <div data-overflow class='c-gauge-bar__overflow-container u-display__none'>
                        <div class='c-gauge-bar__overflow-divider'></div>
                        <div class='c-gauge-bar__overflow-line' data-line></div>
                        <div class='c-gauge-bar__overflow-arrow' data-arrow></div>
                    </div>
                    <div class="c-gauge-bar__min-offset" data-minoffset></div>
                </div>
            </div>`,
            cacheDom: [ 'data-meter', 'data-title', 'data-threshold-label', 'data-bar', 'data-barcontainer', 'data-overflow', 'data-line', 'data-arrow', 'data-minoffset' ]
        };

        super(config);

        this._setAttributes();

        this.onConnectedCallback = () => {
            this.classList.add(`${this.styleSelector}`);
        };
    }

    static get validTypes () {
        return [ 'primary', 'secondary', 'tertiary' ];
    }

    static get observedProps() {
        return [
            new wealthify.Prop('haslabel', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('labelformatter', {type: wealthify.propTypes.FunctionReference()}),
            new wealthify.Prop('max', {
                default: 100,
                type: wealthify.propTypes.Number()
            }),
            new wealthify.Prop('minoffset', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),
            new wealthify.Prop('threshold-lower', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),
            new wealthify.Prop('threshold-upper', {
                default: 0,
                type: wealthify.propTypes.Number()
            }),
            new wealthify.Prop('titleprop', {required: true}),
            new wealthify.Prop('type', {
                default: 'primary' ,
                type: wealthify.propTypes.ArrayItem(this.validTypes)
            }),
            new wealthify.Prop('value', {
                default: 0,
                required: true,
                type: wealthify.propTypes.Number()
            }),
            new wealthify.Prop('w-role', {
                default: 'meter',
                type: wealthify.propTypes.ArrayItem(['meter', 'progressbar'])
            }),
        ];
    }

    get propCallbacks() {
        return {
            haslabel: (value) => {
                const classListAction = value ? 'add' : 'remove';

                this.dom.bar.classList[classListAction](`${this.styleSelector}__bar--with-label`);
                this.dom.arrow.classList[classListAction](`${this.styleSelector}__overflow-arrow--with-label`);

                this._addLabel();
            },
            labelformatter: () => {},
            max: () => {
                this._updateBar();
                this.dom.meter.setAttribute('aria-valuemax', this.max);
            },

            minoffset: (value) => {
                const classListAction = value ? 'add' : 'remove';
                const pointerClassListAction = value ? 'remove' : 'add';

                this._updateBar();
                this.dom.minoffset.innerHTML = value;
                this.dom.barcontainer.classList[classListAction](`${this.styleSelector}__bar-container--has-min-offset`);
                this.dom.minoffset.classList[pointerClassListAction]('u-display__none');
            },
            'threshold-lower': () => {
                this._updateBar();
                this._updateThresholdLabel();
            },
            'threshold-upper': () => {
                this._updateBar();
                this._updateThresholdLabel();
            },
            titleprop: (value) => {
                this.dom.title.innerHTML = value;
            },
            type: (value) => {
                this.constructor.validTypes.forEach((type) => {
                    this.dom.bar.classList.remove(`${this.styleSelector}__bar--type-${type}`);
                    this.dom.line.classList.remove(`${this.styleSelector}__overflow-line--type-${type}`);
                    this.dom.arrow.classList.remove(`${this.styleSelector}__overflow-arrow--type-${type}`);
                });

                this.dom.bar.classList.add(`${this.styleSelector}__bar--type-${value}`);
                this.dom.line.classList.add(`${this.styleSelector}__overflow-line--type-${value}`);
                this.dom.arrow.classList.add(`${this.styleSelector}__overflow-arrow--type-${value}`);
            },
            value: () => {
                if (this.value < this.minoffset) {
                    wealthify.error.throwError(this.tagName, `The prop value (${this.value}) cannot be less than prop minoffset ${this.minoffset}.`);
                }

                this._updateBar();
                this.dom.meter.setAttribute('aria-valuenow', this.value);
            },
            
            'w-role': (value) => {
                this.dom.meter.setAttribute('role', value);
            },
            
        };
    }

    _setAttributes () {
        this.internalId = wealthify.type.number.getRandom();

        this.dom.title.setAttribute('id', `GaugeBar_${this.internalId}_Label`);
        this.dom.thresholdLabel.setAttribute('id', `GaugeBar_${this.internalId}_ThresholdLabel`);
        this.dom.meter.setAttribute('aria-labelledby', `GaugeBar_${this.internalId}_Label`);
        this.dom.meter.setAttribute('aria-describedby', `GaugeBar_${this.internalId}_ThresholdLabel`);
    }

    _updateThresholdLabel() {
        var label = '';

        if (this['threshold-lower'] != null) {
            label += `Lower threshold is ${this['threshold-lower']} or below. `;
        }

        if (this['threshold-upper'] != null) {
            label += `Upper threshold is ${this['threshold-upper']} or above. `;
        }

        this.dom.thresholdLabel.innerText = this.thresholdLabel = label;
    }

    _updateBar() {
        Array.prototype.forEach.call(this.dom.bar.classList, (className) => {
            if (className.indexOf('--value-') !== -1) {
                this.dom.bar.classList.remove(className);
            }
        });

        this.dom.bar.className += this._getValueClass();

        const percentComplete = (this.value / this.max) * 100 || 0;
        const minPercent = 10;

        let widthPercent,
            overflowClassListAction = 'add';

        if (percentComplete === 0) {

            widthPercent = 0;

        } else  if (percentComplete <= 100) {

            widthPercent = this.minoffset
                ? widthPercent = ((this.value - this.minoffset) / (this.max - this.minoffset) * 90) + minPercent
                : widthPercent = (this.value / this.max) * 100;

        } else {
            widthPercent = 100;
            overflowClassListAction = 'remove';
        }

        this.dom.bar.style.width = widthPercent + '%';
        this.dom.overflow.classList[overflowClassListAction]('u-display__none');

        this._addLabel();
    }

    _addLabel () {
        const label = this.haslabel && this.value > 0 ? this.value : '';
        const hasValue = label !== '';
        const valueClassListAction = hasValue ? 'add' : 'remove';

        this.dom.bar.classList[valueClassListAction](`${this.styleSelector}__bar--with-value`);

        this.dom.bar.innerHTML = this.labelformatter && hasValue ? this.labelformatter(label) : label;
    }

    _getValueClass() {
        if (this.value > this.max) {
            return ' c-gauge-bar__bar--value-over';
        } else if (this.value === 0 && this['threshold-lower'] === 0) {
            return '';
        } else if (this.value < this['threshold-lower']) {
            return ' c-gauge-bar__bar--value-low';
        } else if (this.value >= this['threshold-lower'] && this.value <= this['threshold-upper']) {
            return ' c-gauge-bar__bar--value-medium';
        }

        return '';
    }
});